import messages from '../locales/ro_RO.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'ro-RO',
};
export default lang;
